export const isOnline = async (timeout: number = 5000): Promise<boolean> => {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), timeout);
    try {
        const resp = await fetch("/ping", {
            method: "HEAD",
            cache: "no-store",
            signal: controller.signal,
        });
        return resp.ok;
    } catch {
        return false;
    } finally {
        clearTimeout(t);
    }
};
